import {invokeAPI} from './commonBusiness';
import {SignalRHub, SignalREvent} from '../../constants/dataEnum';
// eslint-disable-next-line import/no-cycle
import {gettingAndSetInstalledTray, retractTouchProbe} from './trayCalibrationBusiness';
import {setIsTrayAttached} from '../actions/trayCalibrationStateAction';
import {showModalAutoCalibrationConfirmation} from './modalStateBusinessAction';
import {showLoading} from '../actions/appStateAction';
import {parseMessage} from '../../lib/stringHelper';

export const fetchTrayBarcode = () => async (dispatch) => {
  let response;

  try {
    response = await dispatch(gettingAndSetInstalledTray());
  } catch (err) {
    console.log(err);
  }

  return response;
};

export const fetchProtocolBoundOnTray = (folderId, barcode) => async (dispatch, getState) => {
  const state = getState();
  const {sessionState} = state;
  const {userId} = sessionState.user;

  const response = await dispatch(
    invokeAPI(SignalRHub.TRAY, SignalREvent.GET_PROTOCOL_BIND_ON_TRAY, folderId, barcode, userId, false),
  );

  return response.payload;
};

export const bindProtocolToTray = (protocolId, barcode) => async (dispatch, getState) => {
  const state = getState();
  const {sessionState} = state;
  const {userId} = sessionState.user;

  const response = await dispatch(
    invokeAPI(SignalRHub.TRAY, SignalREvent.BIND_PROTOCOL_TO_TRAY, protocolId, barcode, userId),
  );

  return response.payload;
};

export const isProtocolBoundToTray = (protocolId, folderId, barcode) => async (dispatch) => {
  const protocolsAndFolders = await dispatch(fetchProtocolBoundOnTray(folderId, barcode));
  const {protocols} = protocolsAndFolders;

  return protocols.filter((e) => e.id === protocolId).length > 0;
};

export const safeScanTrayId = () => async (dispatch) => {
  let response;

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_SCAN_TRAY_ID));
  } catch (err) {
    console.log(err);
  }

  return response;
};

export const checkAndSetIsTrayAttached = () => async (dispatch) => {
  const response = await dispatch(fetchTrayBarcode());
  let isAttached = false;

  if (response.result || (response?.tray?.id && response?.tray?.id !== 0)) {
    isAttached = true;
  }

  dispatch(setIsTrayAttached(isAttached));
  return isAttached;
};

export const scanTrayIdWithTouchProbeExtended =
  (
    // eslint-disable-next-line default-param-last
    isShowRemoveLabwareConfirmation = true,
    fastCommonActuatorAPIErrorHandler,
    callback,
  ) =>
  async (dispatch) => {
    if (isShowRemoveLabwareConfirmation) {
      dispatch(
        showModalAutoCalibrationConfirmation(
          () => dispatch(scanTrayIdWithTouchProbeExtended(false, fastCommonActuatorAPIErrorHandler, callback)),
          SignalREvent.SAFE_TOUCH_PROBE_RETRACT,
          false,
        ),
      );

      return;
    }

    // retract touch probe to scan tray id
    await dispatch(retractTouchProbe(fastCommonActuatorAPIErrorHandler, false));

    dispatch(showLoading(parseMessage('modal.missingTray.loading.scanningTray')));
    await dispatch(safeScanTrayId());

    callback();
  };
